import(/* webpackMode: "eager" */ "/www/wwwroot/default/MikroPay/src/app/page.tsx")